//#region IMPORT
import React, { useRef } from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton, Button, Dialog } from '../../../../Components/MUIs';
/** AG-grid Import */

import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import Commons from '../../../../Services/Common/Common';

import dayjs from 'dayjs';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
function AIS_BASIC(props) {
  //#region 변수

  //#endregion
  //#region 웹(컬럼 세팅)
  
  //BLUNEX
  const columnDefs = [
    {
      field: 'custCd',
      headerName: '사업장코드',
      minWidth: 200,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'custNm',
      headerName: '사업장명',
      minWidth: 200,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'createDt',
      headerName: '일자',
      minWidth: 120,
      rowGroup: true, // 그룹
      enableRowGroup: true,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
    {
      field: 'name',
      headerName: '이름',
      minWidth: 120,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'voiceAddress',
      headerName: '파일이름',
      // minWidth: 400,
      flex: 1,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'image',
      headerName: '녹음듣기',
      minWidth: 120,
      cellRenderer: (e) => {
        if (!e.node.group) {
          return (
            <Button
              size="small"
              sx={{ width: '100%' }}
              name={
                '녹음듣기' //설정하기
              }
              onClick={() => {
                popupClickEvent1(e);
              }}
            />
          );
        }
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, // 셀 자체 가운데 정렬
    },
  ];
  //#endregion

  //#region 함수
  const popupClickEvent1 = (_data) => {
    props.SearchLogic3(_data.data);
  };
  const autoGroupColumnDef = React.useMemo(() => {
    //그룹설정
    return {
      headerName: '일자',
      minWidth: 250,
    };
  }, []);
  const rowGroupPanelShow = 'always';
  //#endregion

  return (
    <Grid
      container
      spacing={2}
      columns={{ xs: 4, sm: 8, md: 12 }}
      sx={{ height: '100%' }}
    >
      <Grid xs={4} md={12} sx={{ height: '100%' }}>
        <AuthButton
          menuId="AicallStatus"
          addClick={() => {
            GridFunctions.addClick(props.gridRef);
          }}
          searchYn="Y"
          searchClick={(e) => {
            props.searchRef.current.searchText = e;
            props.SearchLogic1();
          }}
          conditions={[
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                    ).LAN_NM, //기간
              name: Commons.IsMobile()
                ? props.dateValue.startDate
                : '조회일자(시작)',
              value: props.dateValue.startDate
                ? dayjs(props.dateValue.startDate)
                : dayjs(),
              onChange: (date) => {
                let changeDate = dayjs(date).format('YYYY-MM-DD');
                if (date) {
                  // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                  props.setDateValue({
                    ...props.dateValue,
                    startDate: changeDate,
                  });
                  props.SearchLogic2(
                    props.inputs.custCd,
                    changeDate,
                    props.dateValue.endDate
                  );
                }
              },
              currentLocale: 'ko',
            },
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'Period'
                    ).LAN_NM, //기간
              name: Commons.IsMobile()
                ? props.dateValue.endDate
                : '조회일자(끝)', //기간
              value: props.dateValue.endDate
                ? dayjs(props.dateValue.endDate)
                : dayjs(),
              onChange: (date) => {
                let changeDate = dayjs(date).format('YYYY-MM-DD');
                if (date) {
                  // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                  props.setDateValue({
                    ...props.dateValue,
                    endDate: changeDate,
                  });
                  props.SearchLogic2(
                    props.inputs.custCd,
                    props.dateValue.startDate,
                    changeDate
                  );
                }
              },
              currentLocale: 'ko',
            },
            {
              type: 'combo',
              name: '사업장 선택',
              items: props.custList,
              value: props.inputs.custCd,
              onChange: (e) => {
                props.setInputs({
                  ...props.inputs,
                  custCd: e,
                });
                props.SearchLogic2(
                  e,
                  props.dateValue.startDate,
                  props.dateValue.endDate
                );
              },
            },
          ]}
          placeholder="이름"
          grids={
            <BusinessGridCommon
              gridRef={props.gridRef}
              addYn1={'N'}
              deleteYn1={'N'}
              refreshClick1={() => {
                props.SearchLogic1();
              }}
              columnDefs={columnDefs}
              rowGroupPanelShow={rowGroupPanelShow}
              autoGroupColumnDef={autoGroupColumnDef}
              // groupDefaultExpanded={1} // 그룹 펼치기
              rowData={props.rowData}
              setSelectedRowData={props.setSelectedRowData}
              setChangedRowData={props.setChangedRowData}
            />
          }
        />
      </Grid>

      {/* 그리드안 녹음 듣기 팝업 창 */}
      {props.modalToggle1 && (
        <Dialog
          title={'녹음 듣기'}
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length === 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE === 'CALL' && f.LAN_ID === 'Choice'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length === 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE === 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={true}
          maxWidth="sm"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ width: '100%', height: '100%' }}
            >
              {props.voiceUrl ? (
                <audio controls>
                  <source src={props.voiceUrl} type="audio/mpeg" />
                  브라우저가 오디오 태그를 지원하지 않습니다.
                </audio>
              ) : (
                <p>Loading video...</p>
              )}
            </div>
          }
        />
      )}
    </Grid>
  );
}

export default AIS_BASIC;
